<div class="flex-column gap">
    <div class="text-secondary">
        {{ 'ePrescriptions.magistraliterRecipes.sourceNotice' | translate }}
        <a href="https://iplprecept.cz/prescription" target="_blank" rel="noopener noreferrer">IPLP recept</a>
    </div>
    <div>{{ 'ePrescriptions.magistraliterRecipes.reviewNotice' | translate }}</div>

    @if (store.loading()) {
        <app-loading></app-loading>
    } @else if (store.unavailable()) {
        <div role="alert">{{ 'ePrescriptions.magistraliterRecipes.unavailable' | translate }}</div>
        <app-button label="ePrescriptions.magistraliterRecipes.retry" icon="pi-refresh"
            (clickEvent)="store.load()"></app-button>
    } @else {
        <app-text-input [formField]="searchForm.text" icon="pi-search"
            label="ePrescriptions.magistraliterRecipes.search"></app-text-input>
        <app-table
            #recipesTable
            [items]="recipes()"
            [columns]="columns"
            [showPagination]="false"
            [showSearchBar]="false"
            [showFilters]="false"
            [showClearFilter]="false"
            [showDelete]="false"
            [showDetail]="false"
            [enableHidingColumns]="false"
            [disableCopyExport]="true"
            tableKey="iplp-recipes"
            translatePrefix="ePrescriptions.magistraliterRecipes."
            scrollHeight="45vh"
            selectionMode="single"
            behaviorOnRowClick="select"
            (selectionChanged)="selectionChanged($event)"
        >
            <ng-template pTemplate="info" let-item="item">
                <app-button icon="pi-info-circle" styleClass="tableIcon" [text]="true"
                    [title]="'ePrescriptions.magistraliterRecipes.info' | translate"
                    [disabled]="applying()" (clickEvent)="showInfo($event, item)"></app-button>
            </ng-template>
        </app-table>
        @if (store.detailUnavailable()) {
            <div role="alert">{{ 'ePrescriptions.magistraliterRecipes.unavailable' | translate }}</div>
        }
    }
</div>

<p-popover #details [ariaLabel]="'ePrescriptions.magistraliterRecipes.info' | translate" appendTo="body">
    <ng-template #content>
        <div class="recipe-details flex-column gap-small p-3">
            <div class="font-bold">{{ infoRecipe()?.name }}</div>
            @if (store.detailLoading()) {
                <app-loading></app-loading>
            } @else if (store.detailUnavailable()) {
                <div role="alert">{{ 'ePrescriptions.magistraliterRecipes.unavailable' | translate }}</div>
                <app-button label="ePrescriptions.magistraliterRecipes.retry" icon="pi-refresh"
                    (clickEvent)="store.loadDetail(infoRecipe()!.slug)"></app-button>
            } @else if (store.detail(); as recipe) {
                <div class="font-bold">{{ 'ePrescriptions.magistraliterRecipes.prescription' | translate }}</div>
                <div class="recipe-prescription">{{ recipe.prescription }}</div>
                <div class="font-bold">{{ 'ePrescriptions.magistraliterRecipes.insurancePayment' | translate }}</div>
                <div>
                    {{ ('ePrescriptions.magistraliterRecipes.payment.' +
                        (recipe.insurancePayment === null ? 'unknown' : recipe.insurancePayment ? 'yes' : 'no'))
                        | translate }}
                </div>
                @for (section of recipe.sections; track section.key) {
                    <div>
                        <div class="font-bold">
                            {{ ('ePrescriptions.magistraliterRecipes.sections.' + section.key) | translate }}
                        </div>
                        <div [innerHTML]="section.html"></div>
                    </div>
                }
                <a [href]="'https://iplprecept.cz/prescription/' + recipe.slug" target="_blank"
                    rel="noopener noreferrer">{{ 'ePrescriptions.magistraliterRecipes.original' | translate }}</a>
            }
        </div>
    </ng-template>
</p-popover>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        primaryButtonType="custom"
        primaryButtonIcon="pi-check"
        primaryButtonLabel="ePrescriptions.magistraliterRecipes.use"
        [primaryButtonLoading]="applying()"
        [primaryButtonDisability]="!selected() || store.detailLoading() || applying()"
        (primaryClickEvent)="useRecipe()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
